// extracted by mini-css-extract-plugin
module.exports = {"p1":"Text_p1__3Pc5C","p2":"Text_p2__3zz_Q","p2_italic":"Text_p2_italic__3EiJb","action":"Text_action__12PeP","label":"Text_label__2YWVU"};